module.exports = __webpack_public_path__ + "img/Picture26.7c6001c5.png";